import htmlHelpViewer from "./HtmlHelpViewer";

export default htmlHelpViewer;
